import { omitBy } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import { compose, lifecycle, withHandlers, withState } from "recompose"
import { Breadcrumb, Container, Loader, Pagination } from "semantic-ui-react"
import { CaseStatusesTable, SearchForm } from "./components"
import { CaseStatusesApiService } from "./../../api"

const CaseStatusesHistory = ({
	activePage,
	caseStatuses,
	isLoading,
	onPageChange,
	onSearch,
	totalPages
}) => (
	<Container>
		<Breadcrumb>
			<Breadcrumb.Section as={Link} to="/">
				Strona główna
			</Breadcrumb.Section>
			<Breadcrumb.Divider icon="right angle" />
			<Breadcrumb.Section active>Historia statusów spraw</Breadcrumb.Section>
		</Breadcrumb>
		<SearchForm onSubmit={onSearch} />
		{isLoading ? (
			<Loader active={true} content="Ładowanie statusów spraw..." inline="centered" />
		) : (
			<CaseStatusesTable caseStatuses={caseStatuses} />
		)}
		{totalPages > 1 && (
			<Pagination
				activePage={activePage}
				onPageChange={onPageChange}
				totalPages={totalPages}
			/>
		)}
	</Container>
)

CaseStatusesHistory.propTypes = {
	activePage: PropTypes.number,
	caseStatuses: PropTypes.array,
	onPageChange: PropTypes.func,
	onSearch: PropTypes.func.isRequired,
	totalPages: PropTypes.number
}

CaseStatusesHistory.defaultProps = {
	activePage: 1,
	caseStatuses: [],
	onPageChange: () => {},
	totalPages: 1
}

const enhance = compose(
	withState("activePage", "setActivePage", 1),
	withState("caseStatuses", "setCaseStatuses", []),
	withState("isLoading", "setLoading", false),
	withState("searchParams", "setSearchParams", {}),
	withState("totalPages", "setTotalPages", 1),
	withHandlers({
		onPageChange: ({ searchParams, setActivePage, setCaseStatuses, setLoading }) => async (
			e,
			{ activePage }
		) => {
			setActivePage(activePage)
			const params = {
				page: activePage,
				...searchParams
			}
			setLoading(true)
			try {
				const { statuses } = await CaseStatusesApiService.getCaseStatuses(params)
				setCaseStatuses(statuses)
			} finally {
				setLoading(false)
			}
		},
		onSearch: ({
			setActivePage,
			setCaseStatuses,
			setLoading,
			setSearchParams,
			setTotalPages
		}) => async searchParams => {
			const clearedSearchParams = omitBy(
				searchParams,
				param => param === null || param === undefined
			)
			setActivePage(1)
			setSearchParams(clearedSearchParams)
			const params = {
				page: 1,
				...clearedSearchParams
			}
			setLoading(true)
			try {
				const {
					limit,
					statuses,
					totalCount
				} = await CaseStatusesApiService.getCaseStatuses(params)
				setCaseStatuses(statuses)
				const totalPages = Math.ceil(totalCount / limit)
				setTotalPages(totalPages)
			} finally {
				setLoading(false)
			}
		}
	}),
	lifecycle({
		async componentDidMount() {
			const { setCaseStatuses, setLoading, setTotalPages } = this.props
			setLoading(true)
			try {
				const {
					limit,
					statuses,
					totalCount
				} = await CaseStatusesApiService.getCaseStatuses()
				setCaseStatuses(statuses)
				const totalPages = Math.ceil(totalCount / limit)
				setTotalPages(totalPages)
			} finally {
				setLoading(false)
			}
		}
	})
)

export default enhance(CaseStatusesHistory)



// WEBPACK FOOTER //
// ./src/containers/case-statuses-history/CaseStatusesHistory.js